import "./calendar-view.scss";

window.app.directive("calendarView", [
  function() {
    function updateScope(scope) {
      const startDate = moment(scope.startDate());
      const endDate = moment(scope.endDate());

      const monthStartDate = startDate.clone().startOf("month");
      const monthEndDate = monthStartDate.clone().endOf("month");
      const dayCount = monthEndDate.diff(monthStartDate, "days") + 1;

      const offset = monthStartDate.day();
      scope.prePadDays = [...Array(offset).keys()].map(v =>
        monthStartDate
          .clone()
          .day(v)
          .date()
      );

      scope.monthYear = monthStartDate.format("MMMM Y");
      const trailingDayCount = (7 - ((offset + dayCount) % 7)) % 7;
      scope.postPadDays = [...Array(trailingDayCount).keys()].map(v => v + 1);

      scope.days = [...Array(dayCount).keys()].map(v => ({
        num: v + 1,
        date: monthStartDate.clone().add(v, "days")
      }));

      scope.dayInRange = date =>
        date.isBetween(startDate, endDate, "day", "[]");
    }

    return {
      restrict: "E",
      scope: {
        startDate: "&",
        endDate: "&"
      },
      template: (tElement, tAttrs) => {
        return require("./calendar-view.html");
      },
      link: function(scope, element, attrs) {
        scope.$watch(scope => scope.startDate(), () => updateScope(scope));
        scope.$watch(scope => scope.endDate(), () => updateScope(scope));
      },
      controller: [
        "$scope",
        "$element",
        "$state",
        "$timeout",
        "$utils",
        function($scope, $element, $state, $timeout, $utils) {
          $scope.weekDays = "Sun Mon Tue Wed Thu Fri Sat".split(" ");
          updateScope($scope);
        }
      ]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/calendar-view/calendar-view.js